<template>
    <div class="footer-bar">
        <p class="element">
            <a href="/files/UNSUNG_PRIVACY_POLICY.pdf" target="_blank" type="application/pdf">
                Privacy Policy</a>
        </p>
        <hr class="line" />

        <a  class="element" href="https://cert.privo.com/#/companies/kinfolktechfoundation" target="_blank">
        <img class="coppa" src="@/assets/img/COPPA_300.png"/>
      </a>
        <hr class="line" />
        <p class="element">
            <a href="/files/UNSUNG_DATA_RETENTION_AND_DELETION_POLICY.pdf" target="_blank" type="application/pdf">
                Data Handling & Retention Policy</a>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'FooterBar',
    }
</script>

<style>
    .footer-bar {
        height: 75px;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        padding: 30px 0 30px 0;
    }

    .element {
        font-size: 16px;
        text-align: center;
        flex: 1
    }

    .line {
        min-height: 100%;
        max-height: 100vh;
        margin: 0;
        border-right: 2px solid #dfa186;
    }

.coppa {
  width: 100px;
}
</style>